"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedState = void 0;
const react_1 = require("react");
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const use_once_1 = require("./use-once");
const useDebouncedState = (debounceTime, defaultValue) => {
    const [value, setFinalValue] = react_1.useState(defaultValue);
    const [displayValue, setDisplayValue] = react_1.useState(defaultValue);
    const [debouncedSet, setDebouncedSet] = react_1.useState(() => setFinalValue);
    use_once_1.useOnce(() => setDebouncedSet(() => lodash_debounce_1.default(setFinalValue, debounceTime)));
    const setValue = (value) => {
        setDisplayValue(value);
        debouncedSet(value);
    };
    return [value, setValue, displayValue];
};
exports.useDebouncedState = useDebouncedState;
//# sourceMappingURL=use-debounced-state.js.map